import React, { useEffect, useState } from "react";

const TermsComditions = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(`https://servercareseebd.careseebd.com/api/v1/footer/getFooter`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.data.length) {
          setData(data?.data[0]);
        }
      });
  }, []);
  return (
    <div className=" lg:mt-[75px] lg:ml-[175px] lg:mr-[175px] lg:mb-[75px]  m-5  ">
      <div className=" text-center font-bold text-4xl ">
        <h1 className=" underline  decoration-2">Terms & Conditions</h1>
      </div>

      <div className=" text-justify mt-3" dangerouslySetInnerHTML={{ __html: data?.termsAndCondition }}></div>
    </div>

  );
};

export default TermsComditions;
